import { Popover, Whisper } from 'rsuite';
import { SummaryLine, DataviewValue } from '../..';
import './DataviewTooltip.scss';

/**
 * @param {{
 *  dataviewColumns: (CommonClient2.DataviewTableColumn|CommonClient2.DataviewColumn)[];
 *  dataview: any;
 *  label: string;
 *  ignoredKeys?: string[];
 * }} param0
 */
const DataviewTooltip = ({
    dataviewColumns,
    dataview,
    label,
    ignoredKeys,
}) => (
    <Whisper
        placement="rightStart"
        speaker={(
            <Popover title={label}>
                <div className="core--dataview-tooltip">
                    {
                        dataviewColumns
                            .filter((dvc) => !ignoredKeys?.includes(dvc.key))
                            .map(({
                                // @ts-ignore
                                key, tKey: lineLabel, label: title, dataValueType,
                            }) => (
                                <SummaryLine
                                    key={key}
                                    label={lineLabel || title}
                                    value={(
                                        <DataviewValue
                                            dataValueType={dataValueType}
                                            value={dataview[key]}
                                        />
                                    )}
                                />
                            ))
                    }
                </div>
            </Popover>
        )}
    >
        <span>{label}</span>
    </Whisper>
);

export default DataviewTooltip;
